import { useState, useEffect, useCallback } from 'react';
import api from 'services/api';

const ACTION_COLORS = {
  creation: '#22C55E', modification: '#3B82F6', suppression: '#DC2626',
  login: '#8B5CF6', export: '#F59E0B', validation: '#06B6D4',
};

const STATUT_STYLES = {
  succes: { bg: '#F0FDF4', color: '#16A34A', label: 'Succes' },
  echec: { bg: '#FEF2F2', color: '#DC2626', label: 'Echec' },
  bloque: { bg: '#FEF3C7', color: '#D97706', label: 'Bloque' },
};

function actionColor(action) {
  const a = (action || '').toLowerCase();
  for (const [key, color] of Object.entries(ACTION_COLORS)) {
    if (a.includes(key)) return color;
  }
  return '#666';
}

export default function LogsAuditPage() {
  const [tab, setTab] = useState('audit');
  const [logs, setLogs] = useState([]);
  const [stats, setStats] = useState({ total: 0, today: 0, by_type: [] });
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [filters, setFilters] = useState({ entite_type: '', action: '', utilisateur: '', date_debut: '', date_fin: '' });
  const [detailLog, setDetailLog] = useState(null);

  // Connexions state
  const [connexions, setConnexions] = useState([]);
  const [alertesIp, setAlertesIp] = useState([]);
  const [connLoading, setConnLoading] = useState(true);

  const LIMIT = 50;

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const params = { limit: LIMIT, offset: page * LIMIT };
      if (filters.entite_type) params.entite_type = filters.entite_type;
      if (filters.action) params.action = filters.action;
      if (filters.utilisateur) params.utilisateur = filters.utilisateur;
      if (filters.date_debut) params.date_debut = filters.date_debut;
      if (filters.date_fin) params.date_fin = filters.date_fin;

      const [logsRes, statsRes] = await Promise.all([
        api.get('/logs-audit', { params }),
        api.get('/logs-audit/stats'),
      ]);
      setLogs(logsRes.data.logs);
      setTotal(logsRes.data.total);
      setStats(statsRes.data);
    } catch {} finally { setLoading(false); }
  }, [page, filters]);

  const loadConnexions = useCallback(async () => {
    setConnLoading(true);
    try {
      const [connRes, alertRes] = await Promise.all([
        api.get('/logs-audit/connexions'),
        api.get('/logs-audit/connexions/alertes'),
      ]);
      setConnexions(connRes.data);
      setAlertesIp(alertRes.data);
    } catch {} finally { setConnLoading(false); }
  }, []);

  useEffect(() => {
    if (tab === 'audit') load();
    else loadConnexions();
  }, [tab, load, loadConnexions]);

  const setFilter = (k, v) => { setFilters(f => ({ ...f, [k]: v })); setPage(0); };
  const totalPages = Math.ceil(total / LIMIT);

  return (
    <div>
      {/* Tabs */}
      <div style={{ display: 'flex', gap: 0, marginBottom: 20 }}>
        <button
          className={`gss-btn-sm ${tab === 'audit' ? '' : 'gss-btn-cancel'}`}
          onClick={() => setTab('audit')}
          style={{ borderRadius: '6px 0 0 6px', height: 36, fontSize: 13, fontWeight: tab === 'audit' ? 700 : 400, background: tab === 'audit' ? '#8B1A1A' : undefined, color: tab === 'audit' ? '#fff' : undefined }}
        >
          Logs d'audit
        </button>
        <button
          className={`gss-btn-sm ${tab === 'connexions' ? '' : 'gss-btn-cancel'}`}
          onClick={() => setTab('connexions')}
          style={{ borderRadius: '0 6px 6px 0', height: 36, fontSize: 13, fontWeight: tab === 'connexions' ? 700 : 400, background: tab === 'connexions' ? '#8B1A1A' : undefined, color: tab === 'connexions' ? '#fff' : undefined, position: 'relative' }}
        >
          Connexions
          {alertesIp.length > 0 && (
            <span style={{ position: 'absolute', top: -6, right: -6, background: '#DC2626', color: '#fff', borderRadius: '50%', width: 18, height: 18, fontSize: 10, fontWeight: 800, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              {alertesIp.length}
            </span>
          )}
        </button>
      </div>

      {tab === 'audit' ? (
        <>
          <div className="stats-grid">
            <div className="stat-card">
              <div className="stat-card-header"><span className="stat-card-label">Total logs</span></div>
              <div className="stat-card-value">{stats.total}</div>
            </div>
            <div className="stat-card">
              <div className="stat-card-header"><span className="stat-card-label">Aujourd'hui</span></div>
              <div className="stat-card-value" style={{ color: 'var(--gss-success)' }}>{stats.today}</div>
            </div>
            <div className="stat-card">
              <div className="stat-card-header"><span className="stat-card-label">Types d'entites</span></div>
              <div className="stat-card-value">{stats.by_type.length}</div>
            </div>
          </div>

          <div className="content-card">
            <div className="gss-toolbar">
              <div className="content-card-title">Logs d'audit</div>
            </div>

            {/* Filtres */}
            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 16 }}>
              <select className="gss-input" value={filters.entite_type} onChange={e => setFilter('entite_type', e.target.value)} style={{ width: 160 }}>
                <option value="">Toutes entites</option>
                {stats.by_type.map(t => <option key={t.entite_type} value={t.entite_type}>{t.entite_type} ({t.c})</option>)}
              </select>
              <input className="gss-input" placeholder="Utilisateur..." value={filters.utilisateur} onChange={e => setFilter('utilisateur', e.target.value)} style={{ width: 150 }} />
              <input className="gss-input" placeholder="Rechercher action..." value={filters.action} onChange={e => setFilter('action', e.target.value)} style={{ width: 180 }} />
              <input className="gss-input" type="date" value={filters.date_debut} onChange={e => setFilter('date_debut', e.target.value)} style={{ width: 150 }} title="Date debut" />
              <input className="gss-input" type="date" value={filters.date_fin} onChange={e => setFilter('date_fin', e.target.value)} style={{ width: 150 }} title="Date fin" />
              {(filters.entite_type || filters.action || filters.utilisateur || filters.date_debut || filters.date_fin) && (
                <button className="gss-btn-sm" onClick={() => { setFilters({ entite_type: '', action: '', utilisateur: '', date_debut: '', date_fin: '' }); setPage(0); }}>Réinitialiser</button>
              )}
            </div>

            {loading ? <p style={{ textAlign: 'center', padding: '2rem', color: 'var(--gss-text-light)' }}>Chargement...</p> : logs.length === 0 ? (
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '60px 20px' }}>
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#DDD" strokeWidth="1.5"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14,2 14,8 20,8"/></svg>
                <div style={{ fontSize: 16, fontWeight: 600, color: '#666', marginTop: 16 }}>Aucun log</div>
              </div>
            ) : (
              <>
                <div className="gss-table-wrap">
                  <table className="gss-table">
                    <thead><tr><th style={{ width: 140 }}>Date</th><th>Utilisateur</th><th>Rôle</th><th>Action</th><th>Entité</th><th>IP</th><th style={{ width: 60 }}>Détail</th></tr></thead>
                    <tbody>
                      {logs.map(l => (
                        <tr key={l.id}>
                          <td style={{ fontSize: '0.75rem', fontFamily: 'monospace', color: 'var(--gss-text-secondary)' }}>
                            {new Date(l.created_at).toLocaleDateString('fr-FR')}{' '}
                            {new Date(l.created_at).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit', second: '2-digit' })}
                          </td>
                          <td><strong style={{ fontSize: '0.82rem' }}>{l.utilisateur_nom || '-'}</strong></td>
                          <td><span className="gss-badge" style={{ background: 'rgba(0,0,0,0.04)', textTransform: 'uppercase', fontSize: '0.65rem' }}>{l.utilisateur_role || '-'}</span></td>
                          <td>
                            <span style={{ display: 'inline-block', width: 8, height: 8, borderRadius: '50%', background: actionColor(l.action), marginRight: 6, flexShrink: 0 }} />
                            <span style={{ fontSize: '0.82rem' }}>{l.action}</span>
                          </td>
                          <td>
                            <span className="gss-badge" style={{ background: 'var(--gss-red-glow)', color: 'var(--gss-red)', fontSize: '0.7rem' }}>{l.entite_type}</span>
                          </td>
                          <td style={{ fontSize: '0.75rem', fontFamily: 'monospace', color: 'var(--gss-text-light)' }}>{l.ip_address || '-'}</td>
                          <td>
                            {(l.details || l.valeur_avant || l.valeur_apres) && (
                              <button className="gss-btn-sm" onClick={() => setDetailLog(l)}>Voir</button>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                {/* Pagination */}
                {totalPages > 1 && (
                  <div style={{ display: 'flex', justifyContent: 'center', gap: 8, marginTop: 16, alignItems: 'center' }}>
                    <button className="gss-btn-sm" disabled={page === 0} onClick={() => setPage(p => p - 1)}>Precedent</button>
                    <span style={{ fontSize: '0.82rem', color: 'var(--gss-text-secondary)' }}>Page {page + 1} / {totalPages} ({total} resultats)</span>
                    <button className="gss-btn-sm" disabled={page >= totalPages - 1} onClick={() => setPage(p => p + 1)}>Suivant</button>
                  </div>
                )}
              </>
            )}
          </div>
        </>
      ) : (
        <>
          {/* Alertes IP */}
          {alertesIp.length > 0 && (
            <div style={{ background: '#FEF2F2', border: '1px solid #FECACA', borderRadius: 8, padding: '12px 16px', marginBottom: 16 }}>
              <div style={{ fontWeight: 700, fontSize: 13, color: '#DC2626', marginBottom: 6 }}>
                Alertes securite — IP suspectes (3+ echecs en 1h)
              </div>
              {alertesIp.map((a, i) => (
                <div key={i} style={{ fontSize: 12, fontFamily: 'monospace', color: '#991B1B', padding: '2px 0' }}>
                  {a.ip_address} — {a.echecs} echecs — dernier: {new Date(a.dernier).toLocaleTimeString('fr-FR')}
                </div>
              ))}
            </div>
          )}

          <div className="content-card">
            <div className="gss-toolbar">
              <div className="content-card-title">50 dernieres connexions</div>
              <button className="gss-btn-sm" onClick={loadConnexions}>Actualiser</button>
            </div>

            {connLoading ? <p style={{ textAlign: 'center', padding: '2rem', color: 'var(--gss-text-light)' }}>Chargement...</p> : connexions.length === 0 ? (
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '60px 20px' }}>
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#DDD" strokeWidth="1.5"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14,2 14,8 20,8"/></svg>
                <div style={{ fontSize: 16, fontWeight: 600, color: '#666', marginTop: 16 }}>Aucune connexion enregistree</div>
              </div>
            ) : (
              <div className="gss-table-wrap">
                <table className="gss-table">
                  <thead>
                    <tr>
                      <th style={{ width: 140 }}>Date</th>
                      <th>Utilisateur</th>
                      <th>Email</th>
                      <th>Statut</th>
                      <th>IP</th>
                      <th>Details</th>
                    </tr>
                  </thead>
                  <tbody>
                    {connexions.map(c => {
                      const st = STATUT_STYLES[c.statut] || STATUT_STYLES.echec;
                      return (
                        <tr key={c.id}>
                          <td style={{ fontSize: '0.75rem', fontFamily: 'monospace', color: 'var(--gss-text-secondary)' }}>
                            {new Date(c.created_at).toLocaleDateString('fr-FR')}{' '}
                            {new Date(c.created_at).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit', second: '2-digit' })}
                          </td>
                          <td><strong style={{ fontSize: '0.82rem' }}>{c.prenom && c.nom ? `${c.prenom} ${c.nom}` : '-'}</strong></td>
                          <td style={{ fontSize: '0.82rem' }}>{c.email}</td>
                          <td>
                            <span className="gss-badge" style={{ background: st.bg, color: st.color, fontWeight: 700, fontSize: '0.7rem' }}>
                              {st.label}
                            </span>
                          </td>
                          <td style={{ fontSize: '0.75rem', fontFamily: 'monospace', color: 'var(--gss-text-light)' }}>
                            {c.ip_address || '-'}
                          </td>
                          <td style={{ fontSize: '0.75rem', color: 'var(--gss-text-light)' }}>
                            {c.details && typeof c.details === 'object' && Object.keys(c.details).length > 0
                              ? Object.entries(c.details).map(([k, v]) => `${k}: ${v}`).join(', ')
                              : '-'}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </>
      )}

      {/* Modal detail */}
      {detailLog && (
        <div className="gss-modal-overlay" onClick={() => setDetailLog(null)}>
          <div className="gss-modal" onClick={e => e.stopPropagation()} style={{ maxWidth: 600 }}>
            <div className="gss-modal-header">
              <h2>Detail du log</h2>
              <button className="gss-modal-close" onClick={() => setDetailLog(null)}>&times;</button>
            </div>
            <div style={{ padding: '1.5rem' }}>
              <div className="gss-form-grid">
                <div className="gss-field"><label>Date</label><div style={{ fontSize: '0.85rem' }}>{new Date(detailLog.created_at).toLocaleString('fr-FR')}</div></div>
                <div className="gss-field"><label>Utilisateur</label><div style={{ fontSize: '0.85rem' }}>{detailLog.utilisateur_nom || '-'}</div></div>
                <div className="gss-field"><label>Action</label><div style={{ fontSize: '0.85rem', fontWeight: 600 }}>{detailLog.action}</div></div>
                <div className="gss-field"><label>Entite</label><div style={{ fontSize: '0.85rem' }}>{detailLog.entite_type}</div></div>
                {detailLog.ip_address && <div className="gss-field"><label>Adresse IP</label><div style={{ fontSize: '0.85rem', fontFamily: 'monospace' }}>{detailLog.ip_address}</div></div>}
              </div>
              {detailLog.details && (
                <div style={{ marginTop: 16 }}>
                  <label style={{ fontSize: '0.78rem', fontWeight: 600, color: 'var(--gss-text-secondary)', textTransform: 'uppercase' }}>Details</label>
                  <pre style={{ background: '#F5F5F5', padding: 12, borderRadius: 8, fontSize: '0.75rem', overflow: 'auto', maxHeight: 200, marginTop: 4 }}>
                    {JSON.stringify(detailLog.details, null, 2)}
                  </pre>
                </div>
              )}
              {detailLog.valeur_avant && (
                <div style={{ marginTop: 12 }}>
                  <label style={{ fontSize: '0.78rem', fontWeight: 600, color: '#DC2626', textTransform: 'uppercase' }}>Valeur avant</label>
                  <pre style={{ background: '#FEF2F2', padding: 12, borderRadius: 8, fontSize: '0.75rem', overflow: 'auto', maxHeight: 150, marginTop: 4 }}>
                    {JSON.stringify(detailLog.valeur_avant, null, 2)}
                  </pre>
                </div>
              )}
              {detailLog.valeur_apres && (
                <div style={{ marginTop: 12 }}>
                  <label style={{ fontSize: '0.78rem', fontWeight: 600, color: '#22C55E', textTransform: 'uppercase' }}>Valeur apres</label>
                  <pre style={{ background: '#F0FDF4', padding: 12, borderRadius: 8, fontSize: '0.75rem', overflow: 'auto', maxHeight: 150, marginTop: 4 }}>
                    {JSON.stringify(detailLog.valeur_apres, null, 2)}
                  </pre>
                </div>
              )}
            </div>
            <div className="gss-modal-actions">
              <button className="gss-btn-cancel" onClick={() => setDetailLog(null)}>Fermer</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
